import { ArrayItem, EXT_mesh_gpu_instancing, GLTFLoader } from "@babylonjs/loaders/glTF/2.0";
import { EXT_mesh_features } from "./EXT_mesh_features";
const NAME = "EXT_instance_features";
export class EXT_instance_features {
    constructor(loader) {
        this.name = NAME;
        this._loader = loader;
        this.enabled = this._loader.isExtensionUsed(NAME) && this._loader.isExtensionUsed(EXT_mesh_gpu_instancing.name);
    }
    dispose() {
        this._loader = null;
    }
    loadNodeAsync(context, node, assign) {
        if (node.extensions) {
            const ext_gpu_instancing = node.extensions[EXT_mesh_gpu_instancing.name];
            if (ext_gpu_instancing) {
                return GLTFLoader.LoadExtensionAsync(context, node, this.name, (extensionContext, extension) => {
                    const promise = this._loader.loadNodeAsync(`/nodes/${node.index}`, node, assign);
                    if (!node._primitiveBabylonMeshes) {
                        return promise;
                    }
                    for (const babylonMesh of node._primitiveBabylonMeshes) {
                        const babylonObject = babylonMesh;
                        const gpu_instancing_context = `${context}.${EXT_mesh_gpu_instancing.name}`;
                        const featureIds = (babylonObject.featureIds = babylonObject.featureIds ?? []);
                        for (const fid of extension.featureIds) {
                            featureIds.push(fid);
                            if (fid.attribute != undefined) {
                                const n = EXT_mesh_features.BuildKind("_FEATURE_ID_", fid.attribute);
                                const accessor = ArrayItem.Get(`${gpu_instancing_context}/attributes/${n}`, this._loader.gltf.accessors, ext_gpu_instancing.attributes[n]);
                                this._loader._loadIndicesAccessorAsync(`/accessors/${accessor.bufferView}`, accessor).then((data) => {
                                    babylonObject.thinInstanceIds = babylonObject.thinInstanceIds ?? [];
                                    babylonObject.thinInstanceIds.push(data);
                                });
                            }
                        }
                    }
                    return promise;
                });
            }
        }
        return null;
    }
}
GLTFLoader.RegisterExtension(NAME, (loader) => new EXT_instance_features(loader));
//# sourceMappingURL=EXT_instance_features.js.map